import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectHelpTopicsListItems } from '../../../../../redux/help-topics/selector';
import { deepCopy } from '../../../../../common/services/common.service';
import { helpTopics } from '../../../../../redux/help-topics/action';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import HelpTopicComponent from '../../help-topics/components/help-topic.component';
import PageLoader from '../../../../../components/PageLoader';

let currentChange: any = {}
const HelpTopicContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const helpTopicsItems = useSelector(selectHelpTopicsListItems)
  const [
    selectedHelpTopic,
    setSelectedHelpTopic
  ] = useState<any>({})
  const [
    helpTopicImageIndex,
    setHelpTopicImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const handleFormItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.HelpTopicDocumentURLs);
    items[idx] = { ...items[idx], [field]: value };
    setMediaFiles(items);
    const updatedCardValue = [...selectedHelpTopic];
    updatedCardValue[idx1] = { ...cardValue, HelpTopicDocumentURLs: items };
    setSelectedHelpTopic(updatedCardValue);
  }


  const handleFormHelpTopicItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedHelpTopic);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedHelpTopic(items);
  }

  useEffect(
    () => {
      dispatch(helpTopics.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`, entity: 'helpTopics', jsonData: {}
      }))
      if (cardDetailInfo) {
        console.log(cardDetailInfo, 'cardDetailInfo')
        let HelpTopics: any = null
        HelpTopics = Object.values(cardDetailInfo)
        let HelpTopicData: any = HelpTopics?.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            OwnerTypeId: item?.OwnerTypeId,
            OwnerId: item?.OwnerId,
            Title: item?.Title,
            Body: item?.Body,
            ParentId: item?.ParentId,
            HelpTopicDocumentURLs: item?.HelpTopicDocumentURLs?.map((imageItem: any) => {
              return {
                Id: imageItem?.Id || 0,
                HelpTopicId: imageItem?.HelpTopicId || selectedHelpTopic?.Id || 0,
                FileTypeId: imageItem?.FileTypeId || 10,
                FileMappingURL: imageItem?.HelpTopicFileURL
              };
            }),
          }
          return itemData
        })

        if (!HelpTopicData) {
          HelpTopicData = []
        }
        const localSelectedHelpTopic = addNewRow({ selectedHelpTopicArg: HelpTopicData });
        setSelectedHelpTopic(localSelectedHelpTopic)
        const mediaFile = HelpTopicData.map((brandMapping: any, index: any) => {
          const localSelectedlogo = addNewMediaFilesRow({
            selectedMediaFilesArg: brandMapping?.HelpTopicDocumentURLs,
            brandMapping: localSelectedHelpTopic,
            idx: brandMapping?.HelpTopicDocumentURLs?.length,
            idx1: index
          });
          return localSelectedlogo;
        });

        setMediaFiles(mediaFile)
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
      }
    },
    [cardDetailInfo]
  )
  const addNewRow = ({ selectedHelpTopicArg }: any) => {
    const localSelectedHelpTopic = Array.isArray(selectedHelpTopicArg)
      ? deepCopy(selectedHelpTopicArg)
      : Object.values(deepCopy(selectedHelpTopicArg));
    const newsSelectedMedia = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,
      Title: '',
      Body: '',
      ParentId: 0,
      HelpTopicDocumentURLs: [
        {
          Id: 0,
          HelpTopicId: 0,
          FileTypeId: 0,
          HelpTopicFileURL: "string"
        }
      ]

    };

    if (
      localSelectedHelpTopic.length === 0 ||
      localSelectedHelpTopic[localSelectedHelpTopic.length - 1]?.Title !== ''
    ) {
      localSelectedHelpTopic.push(newsSelectedMedia);
    }

    return localSelectedHelpTopic;
  };
  const setCombinationHelpTopicInfo = async () => {
    let localSelectedHelpTopic = deepCopy(selectedHelpTopic)
    localSelectedHelpTopic.splice(
      currentChange.idx,
      1,
      { ...localSelectedHelpTopic[currentChange.idx] }
    );
    localSelectedHelpTopic = addNewRow({ selectedHelpTopicArg: localSelectedHelpTopic });
    currentChange.field = 'TitleDONE'
    setSelectedHelpTopic(localSelectedHelpTopic)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Title') {
        setCombinationHelpTopicInfo()
      }
    },
    [selectedHelpTopic]
  )

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }
  const handleFormSubmit = async (event: any) => {

    selectedHelpTopic.splice(
      selectedHelpTopic.length - 1,
      1
    );
    const blogData: any = selectedHelpTopic.map((item: any) => {
      if (item?.HelpTopicDocumentURLs?.length) {
        item.HelpTopicDocumentURLs.splice(item.HelpTopicDocumentURLs.length - 1, 1);
      }
      const itemData = {
        Id: item?.Id,
        OwnerTypeId: item?.OwnerTypeId || 0,
        OwnerId: item?.OwnerId || 0,
        Title: item?.Title,
        Body: item?.Body,
        ParentId: item?.ParentId,
        HelpTopicDocumentURLs: item?.HelpTopicDocumentURLs?.map((logoItem: any) => {
          return {
            Id: logoItem?.Id,
            HelpTopicId: logoItem?.HelpTopicId,
            FileTypeId: logoItem?.FileTypeId,
            HelpTopicFileURL: logoItem?.FileMappingURL
          };
        }),
      }
      return itemData
    })
    onSubmit(blogData)

  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      HelpTopicId: selectedHelpTopic?.Id,
      FileTypeId: 0,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      brandMapping[idx1]?.HelpTopicDocumentURLs[brandMapping[idx1].HelpTopicDocumentURLs?.length - 1]?.FileTypeId !== ''
    ) {

      brandMapping[idx1]?.HelpTopicDocumentURLs?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia, brandMapping: selectedHelpTopic, idx1: currentChange.idx });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    setHelpTopicImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: brandMaping[idx1]?.HelpTopicDocumentURLs[idx][templateField],
      folder: 'HelpTopic',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }

  }
  const handleSubmit = (data: any) => {
    const newLogoFiles = [...mediaFiles];
    const currentBlog = selectedHelpTopic[currentChange.idx1]; // Retrieve the current blog based on idx1
    const logosArray = currentBlog?.HelpTopicDocumentURLs;

    // Check if the first row and first record is being updated
    if (currentChange.idx1 === 0 && currentChange.idx === 0) {
      // Update the existing file mapping without adding a new row
      logosArray[currentChange.idx].FileMappingURL = data;

      // Update the media files without adding a new row
      setMediaFiles([...newLogoFiles]);
      return;
    }

    // If it's not the first row or first record, proceed to add a new row
    logosArray[currentChange.idx].FileMappingURL = data;

    const localSelectedMedia = addNewMediaFilesRow({
      selectedMediaFilesArg: newLogoFiles,
      brandMapping: selectedHelpTopic,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data,
    });

    setMediaFiles(localSelectedMedia);
  };

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
      />}
      {isLoading ? <PageLoader /> :
        <HelpTopicComponent
          handleFormHelpTopicItemChange={handleFormHelpTopicItemChange}
          handleFormSubmit={handleFormSubmit}
          selectedHelpTopic={selectedHelpTopic}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          changeImage={changeImage}
          helpTopics={helpTopicsItems?.result?.items}
        />
      }

    </>
  )

}

export default HelpTopicContainer;
